import { FC } from 'react';

type Props = {
	className?: string;
};

const Exchange_01_Icon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M13.8708 15.8333C15.7569 14.5792 17 12.4348 17 10C17 6.13401 13.866 3 10 3C9.46536 3 8.94471 3.05994 8.44444 3.17346M13.8708 15.8333V13.1111M13.8708 15.8333H16.6111M6.11111 4.17876C4.23513 5.4345 3 7.57301 3 10C3 13.866 6.13401 17 10 17C10.5346 17 11.0553 16.94 11.5556 16.8266M6.11111 4.17876V6.88889M6.11111 4.17876H3.38889'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Exchange_01_Icon;
